import React, { Component } from 'react'
import { connect } from 'react-redux'
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Transition, Message } from 'semantic-ui-react'

import http from '../utils/http-common'
import { setMenuVisible } from '../actions'

import styles from './Contact.module.scss'
import './Contact.css'
import MenuIconDesktop from '../components/MenuIconDesktop';
import {loadResourcesDepartment} from "../utils/homeUtils";

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      language: "",
      contact : {
        contactDescription: "",
        name: "",
        phone: "",
        item: "",
        title: "",
        email: "",
        content: "",
        address: "",
        itemOption1: "",
        itemOption2: "",
        itemOption3: "",
        itemOption4: "",
        itemOption5: ""
      },
      contactInput : {
        name: "",
        phone: "",
        item: "",
        title: "",
        email: "",
        content: "",
        recaptcha: "",
      },
      messageVisible: false,
      errorMessageVisible: false,
      refreshReCaptcha: true
    }

    this.contact = {
      contactDescription: "",
      name: "",
      phone: "",
      item: "",
      title: "",
      email: "",
      content: "",
      address: "",
      itemOption1: "",
      itemOption2: "",
      itemOption3: "",
      itemOption4: "",
      itemOption5: ""
    }

    this.contactInput = {
      name: "",
      phone: "",
      item: "",
      title: "",
      email: "",
      content: "",
      recaptcha: "",
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMessageClick = this.handleMessageClick.bind(this);
    this.handleErrorMessageClick = this.handleErrorMessageClick.bind(this);
    this.getLanguage = this.getLanguage.bind(this);
    this.clearInputAndShowMessage = this.clearInputAndShowMessage.bind(this);
    this.updateToken = this.updateToken.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
  }

  componentDidMount() {
    loadResourcesDepartment();
    this.getLanguage();

    this.handleLoaded();
  }

  handleLoaded = _ => {
    window.grecaptcha.ready(_ => {
      this.updateToken();

      setInterval(()=>{
        this.updateToken();
      }, 100000);
    })
  }

  handleSubmit() {
    if ((this.contactInput.content) && (this.contactInput.recaptcha !== "" || this.contactInput.recaptcha !== null)) {

      http.post("/api/v1/contact/mail", this.contactInput)
      .then((res)=>{
        if (res.data.stackTrace !== null) {
        }
      }).catch(function (error){
      });

      this.clearInputAndShowMessage();
    }
  }

  clearInputAndShowMessage() {
    this.contactInput = {
      name: "",
      phone: "",
      item: "",
      title: "",
      email: "",
      content: ""
    }
    this.setState({
      contactInput: JSON.parse(JSON.stringify(this.contactInput)),
      messageVisible: true
    });

    setTimeout(()=>{
      this.setState({messageVisible: false});
    }, 3000);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.language !== this.props.language) {
      this.getLanguage();
    }

    // if (this.state.refreshReCaptcha) {
    //   console.log("is refreshReCaptcha");
    // }
  }

  getLanguage() {
    http.get("/api/v1/contact?language=" + localStorage.getItem("language"))
        .then(res=>{
          this.setState({contact: res.data});
        }).catch(error=>{console.log(error)});
  }

  handleMessageClick(e, data) {
    this.setState({messageVisible: false});
  }

  handleErrorMessageClick(e, data) {
    this.setState({errorMessageVisible: false});
  }

  getLanguageClass = () => {
    switch(this.props.language) {
      case "EN":
        return styles.en;
      default:
        return '';
    }
  }

  updateToken = _ => {
    window.grecaptcha
        .execute("6Ld-WpwaAAAAADAGMapn4v7ZY-627_QWHuIo4kLL", { action: "homepage" })
        .then(token => {
          // console.log(token);
          this.contactInput.recaptcha = token;
        })
  }

  render() {
    return (
      <>
        <div className={`contact ${styles.contact} ${styles.desktop} ${this.getLanguageClass()}`}>
          {/* <div className={styles.background_wrapper}></div> */}
          <Transition visible={this.props.isPageVisible} animation='fade' duration={2000}>
            <MenuIconDesktop />
          </Transition>
          <Transition visible={this.props.isPageVisible} animation='fade' duration={2000}>
            <div className={styles.page_wrapper}>
              <div className={styles.title}>
                <div className={styles.title_word}>Contact Us</div>
                <div className={styles.subtitle_block}>
                  <div className={styles.subtitle_word}>OUTLAND Film Production</div>
                </div>
              </div>
              <div className={styles.contact_wrapper}>
                <div className={styles.background_overlay}></div>
                <div className={styles.information_wrapper}>
                  <div className={styles.information_description} dangerouslySetInnerHTML={{__html: this.state.contact.contactDescription}}>
                    {/*<div>若有開發、製作需求者，</div>*/}
                    {/*<div>亦或是想參與拍片者</div>*/}
                    {/*<div>歡迎填寫官方表單或來電洽詢！</div>*/}
                  </div>
                  <div className={styles.contact_icons}>
                    <div className={styles.mail} onClick={() => {
                      window.open("mailto:outlandfilms@gmail.com")
                    }}></div>
                    <div className={styles.facebook} onClick={() => {
                      window.open("https://www.facebook.com/outlandfilmproduction/")
                    }}></div>
                  </div>
                  <div className={styles.information_contact}>
                    <div className={styles.tel}>Tel. +886-2-2872-3140</div>
                    <div className={styles.tel}>Fax. +886-2-2872-1774</div>
                    <div className={styles.address}>{this.state.contact.address}</div>
                  </div>
                </div>
                <div className={styles.form_wrapper}>
                  <div className={styles.titles}>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.name}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.phone}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.item}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.title}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.email}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.contact}</div>
                  </div>
                  <div className={styles.inputs}>
                    <div name="name" className={styles.input_content}>
                      <input type="text" className={styles.short} value={this.state.contactInput.name} onChange={(e) =>{
                        this.contactInput.name = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div name="phone" className={styles.input_content}>
                      <input type="text" className={styles.short} value={this.state.contactInput.phone} onChange={(e) =>{
                        this.contactInput.phone = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div className={styles.input_content}>
                      <select name="item" className={styles.options} value={this.state.contactInput.item} onChange={(e) =>{
                        this.contactInput.item = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}>
                        <option>{this.state.contact.itemOption1}</option>
                        <option>{this.state.contact.itemOption2}</option>
                        <option>{this.state.contact.itemOption3}</option>
                        <option>{this.state.contact.itemOption4}</option>
                        <option>{this.state.contact.itemOption5}</option>
                      </select>
                    </div>
                    <div name="title" className={styles.input_content}>
                      <input type="text" className={styles.long} value={this.state.contactInput.title} onChange={(e) =>{
                        this.contactInput.title = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div name="email" className={styles.input_content}>
                      <input type="text" className={styles.long} value={this.state.contactInput.email} onChange={(e) =>{
                        this.contactInput.email = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div name="content" className={styles.input_content}>
                      <textarea className={`${styles.long} ${styles.textarea}`} value={this.state.contactInput.content} onChange={(e) =>{
                        this.contactInput.content = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></textarea>
                    </div>
                    
                    <div className={styles.button_groups}>
                      <div className={styles.submit} onClick={() => {
                        this.handleSubmit()
                      }}></div>
                      <div className={styles.cancel}></div>
                    </div>

                    <div>
                      This site is protected by reCAPTCHA and the Google
                      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </div>
                  </div>

                </div>

                <Message positive className={`message ${styles.message}`} hidden={!this.state.messageVisible} visible={this.state.messageVisible} onDismiss={this.handleMessageClick}>
                  {this.props.language === "TW"
                      ? <Message.Header>謝謝您的來信，我們會盡快與您聯絡</Message.Header>
                      : <Message.Header>Thank you for your inquiry. We will get back to you as soon as possible.</Message.Header>
                  }
                </Message>

                <Message positive className={`message ${styles.message}`} hidden={!this.state.errorMessageVisible} visible={this.state.errorMessageVisible} onDismiss={this.handleErrorMessageClick}>
                  {this.props.language === "TW"
                      ? <Message.Header>謝謝您的來信，我們會盡快與您聯絡</Message.Header>
                      : <Message.Header>Thank you for your inquiry. We will get back to you as soon as possible.</Message.Header>
                  }
                </Message>

              </div>
            </div>
          </Transition>

        </div>

        <div className={`contact ${styles.contact} ${styles.mobile} ${this.getLanguageClass()}`}>
          <div className={styles.menu_wrapper}>
            <div className={styles.menu} onClick={() => {
              this.props.setMenuVisible(true)
            }}>
              <span className={styles.menu_icon}><div
                className={styles.menu_icon_line}></div></span>
              <span>OUTLAND Film Production</span>
            </div>
          </div>
          <div className={styles.page_wrapper}>
            <div className={styles.background_wrapper}>
              <div className={styles.background_overlay}></div>
              <div className={styles.contact_wrapper}>
                <div className={styles.contact_us}>Contact Us</div>
                <div className={styles.form_wrapper}>
                  <div className={styles.titles}>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.name}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.phone}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.item}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.title}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.email}</div>
                    <div className={`${styles.input_title} justify_line`}>{this.state.contact.contact}</div>
                  </div>
                  <div className={styles.inputs}>
                    <div className={styles.input_content}>
                      <input type="text" className={styles.long} value={this.state.contactInput.name} onChange={(e) =>{
                        this.contactInput.name = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div className={styles.input_content}>
                      <input type="text" className={styles.long} value={this.state.contactInput.phone} onChange={(e) =>{
                        this.contactInput.phone = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div className={styles.input_content}>
                      <select className={styles.long} value={this.state.contactInput.item} onChange={(e) =>{
                        this.contactInput.item = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}>
                        <option>{this.state.contact.itemOption1}</option>
                        <option>{this.state.contact.itemOption2}</option>
                        <option>{this.state.contact.itemOption3}</option>
                        <option>{this.state.contact.itemOption4}</option>
                        <option>{this.state.contact.itemOption5}</option>
                      </select>
                    </div>
                    <div className={styles.input_content}>
                      <input type="text"  value={this.state.contactInput.title} className={styles.long} onChange={(e) =>{
                        this.contactInput.title = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div className={styles.input_content}>
                      <input type="text" className={styles.long} value={this.state.contactInput.email} onChange={(e) =>{
                        this.contactInput.email = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></input>
                    </div>
                    <div className={styles.input_content}>
                      <textarea type="textarea" className={`${styles.long} ${styles.textarea}`} value={this.state.contactInput.content} onChange={(e) =>{
                        this.contactInput.content = e.target.value;
                        this.setState({ contactInput: JSON.parse(JSON.stringify(this.contactInput)) });
                      }}></textarea>
                    </div>

                    <div className={styles.button_groups}>
                      <div className={styles.submit} onClick={() => {
                        this.handleSubmit()
                      }}></div>
                      <div className={styles.cancel}></div>
                    </div>

                  </div>

                </div>

                <div className={`${styles.policy}`}>
                  This site is protected by reCAPTCHA and the Google
                  <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                  <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                </div>

                <Message positive className={`message ${styles.message}`} hidden={!this.state.messageVisible} visible={this.state.messageVisible} onDismiss={this.handleMessageClick}>
                  {this.props.language === "TW"
                      ? <Message.Header>謝謝您的來信，我們會盡快與您聯絡</Message.Header>
                      : <Message.Header>Thank you for your inquiry. We will get back to you as soon as possible.</Message.Header>
                  }
                </Message>

              </div>
            </div>
          </div>

          <div className={styles.information_wrapper}>
            <div className={styles.contact_icons}>
              <div className={styles.mail} onClick={() => {
                window.open("mailto:outlandfilms@gmail.com")
              }}></div>
              <div className={styles.facebook} onClick={() => {
                window.open("https://www.facebook.com/outlandfilmproduction/")
              }}></div>
            </div>
            <div className={styles.information_contact}>
              <div></div>
              <div>Tel. +886-2-2872-3140</div>
              <div>Fax. +886-2-2872-1774</div>
              <div>{this.state.contact.address}</div>
            </div>
          </div>


        </div>
      </>
    );
  }

};

const mapStateToProps = state => {
  return {
    isPageVisible: state.isPageVisible,
    language: state.language
  };
};

export default connect(mapStateToProps, { setMenuVisible })(Contact);
